import { useInfiniteQuery, useQueryClient } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import APICall from "../../APICall";
import EndPoints from "../../APICall/EndPoints";
import DashboardCommonTable from "../../components/DashboardCommonTable";
import { Col, notification, Row, Tooltip } from "antd";
import VerificationModal from "../../components/VerificationModal/VerificationModal";
import { ClientNameCol, SmallTag, StyledOverFlowDiv, onlyTime } from "./style";
import {
  findMarket,
  formatNumber,
} from "../../components/FormateToINR/formatToINR";
import { limitNumberLength } from "../../components/SocketLiveData";
import {
  readableString,
  valanBillDate,
} from "../../components/CommanFuction/CommanFunction";
import { styleTheme } from "./style";
import { UplineTag } from "../Users/Accounts/style";
import { labelObj, marketTag } from "../../Helper/constant";
import { MarketTableTag } from "../MarketWatch/style";
import { DesktopOutlined, MobileOutlined } from "@ant-design/icons";

const RejectionLogsTable = React.memo(
  ({
    customerScreen,
    queryType = "childRejectionLogs",
    pageType = "childRejectionLogsPagination",
    filterValue,
  }) => {
    const queryClient = useQueryClient();
    const [showModal, setShowModal] = useState({ flag: false, record: null });
    const [loading, setLoading] = useState(false);

    //redux
    const loginAccountType = useSelector(
      (state) => state?.authSlice?.userDetail?.accountType
    );
    const addition = useSelector(
      (state) => state?.authSlice?.additionalSharing
    );
    const isAllow =
      loginAccountType !== "customer" && loginAccountType !== "broker";
    const isStale = queryClient
      .getQueryCache()
      .find(["rejectionLogs"])
      ?.isStale();

    // life cycle
    useEffect(() => {
      if (isStale) {
        queryClient.invalidateQueries({ queryKey: ["rejectionLogs"] });
      }
    }, []);

    // api call
    const getRejectionLog = async ({ pageParam = 1 }) => {
      let obj = {
        query: {
          [queryType]: {
            page: pageParam,
            limit: 10,
          },
        },
      };
      if (filterValue) obj = { ...obj, filters: { ...filterValue } };
      let url = `${EndPoints.getTradeLog}`;
      if (!customerScreen) url += "?isLatest=true";
      let response = await APICall("post", url, obj);
      // console.log("rejectionLogs", response?.data?.data);
      return response?.data?.data;
    };

    const tradeQuery = useInfiniteQuery({
      queryKey: customerScreen
        ? ["rejectionLogs", filterValue]
        : ["rejectionLogs"],
      queryFn: getRejectionLog,
      getNextPageParam: (lastPage) => lastPage?.[pageType]?.nextPage,
    });

    if (tradeQuery?.error) {
      notification.error({ message: tradeQuery?.error?.message });
    }

    const totalData = tradeQuery?.data?.pages?.flatMap((el) => el?.[queryType]);

    //function
    const handleExecute = async (record, index) => {
      setLoading(true);
      try {
        let response = await APICall(
          "get",
          `${EndPoints.exucuteRejectedTrade}${record?._id}`
        );
        if (response?.status === 200) {
          notification.success({ message: response.data?.message });
          // setShowModal({ flag: false, record: null });
        } else {
          notification.error({ message: response?.data?.message });
        }
      } catch (error) {
        console.log("error", error);
      } finally {
        setLoading(false);
        setShowModal({ flag: false, record: null });
        queryClient.refetchQueries({ queryKey: ["rejectionLogs"] });
      }
    };

    const handleCancel = () => {
      setShowModal({ flag: false, record: null });
    };

    // column
    const rejectionColumn = [
      {
        title: "",
        dataIndex: "index",
        key: "index",
        align: "left",
        render: (text, record, index) => {
          return (
            <div>
              {record?.deviceType === "mob" ? <MobileOutlined /> : record?.deviceType === "web" ? <DesktopOutlined /> : "-"}
            </div>
          );
        },
      },
      {
        title: "TIME",
        dataIndex: "client",
        key: "time",
        align: "left",
        flex: 1,
        render: (text, record) => {
          const time = onlyTime(record?.tradeTime);
          return <span>{time}</span>;
        },
      },
      {
        title: "CLIENT",
        dataIndex: "client",
        key: "client",
        align: "left",
        flex: 1,
        ellipsis: true,
        render: (text, record) => {
          return (
            <>
              {/* <Tooltip
              title={`${record?.client?.userId} (${record?.client?.accountName})`}
              placement="top"
            > */}
              <div>
                <div style={{ fontWeight: "bold" }}>{record?.client?.userId}</div>
                <div >{record?.client?.accountName}</div>
              </div>
              {/* </Tooltip> */}
            </>
          );
        },
      },
      {
        title: "UPLINE",
        dataIndex: "upline",
        key: "upline",
        align: "left",
        flex: 1,
        ellipsis: true,
        render: (text, record) => {
          let id = record?.client?.parent?.userId;
          return (
            <>
              {/* <Tooltip
              title={`${id} (${record?.client?.parent?.accountName})`}
              placement="top"
            > */}
              <div>
                <div style={{ fontWeight: "bold" }}>{id}<UplineTag color="magenta" bordered={false}>
                  {labelObj[record?.client?.parent?.accountType]}
                </UplineTag></div>
                <div >{record?.client?.parent?.accountName}</div>
              </div>
              {/* </Tooltip> */}
            </>
          );
        },
      },
      {
        title: "MARKET",
        dataIndex: "marketName",
        key: "marketName",
        flex: 1,
        render: (text, record) => {
          return <div>
            {/* <Tooltip title={record?.marketName} placement={"leftTop"}> */}
            <MarketTableTag color="volcano-inverse">
              {marketTag[record?.marketName]}
            </MarketTableTag>
            {/* </Tooltip> */}
          </div>;
        },
      },
      {
        title: "SCRIPT",
        dataIndex: "scriptName",
        key: "scriptName",
        align: "left",
        filterMultiple: false,
        className: "table-filter",
        render: (text, record) => {

          const date = valanBillDate(record?.expiryDate, false);
          const opt = record?.marketName?.endsWith("OPT");
          const name = opt
            ? `${record?.symbolName} ${record?.series ? record?.series : ""} ${record?.strikePrice ? record?.strikePrice : ""
            }`
            : record?.symbolName;
          return (
            <div>
              <div style={{ textAlign: "left", display: "flex" }}>
                {name}  <SmallTag color="orange" variant="solid" bordered={false}>
                  {record?.title}
                </SmallTag>
                <SmallTag
                  color={record?.tradePattern === "buy" ? "green" : "red"}
                  variant="solid"
                  bordered={false}
                >
                  {record?.tradePattern.toUpperCase()}
                </SmallTag>
              </div>
              <div style={{ textAlign: "left", fontSize: "10px", fontWeight: "bold" }}>
                {date}
              </div>

            </div>
          );
        },
      },
      {
        title: "QTY (LOT)",
        dataIndex: "lot",
        key: "lot",
        width: "10rem",
        align: "left",
        render: (text, record) => {
          const lot = formatNumber(record?.lot);
          const quantity = formatNumber(record?.quantity);
          const data =
            record?.marketName === "NSE EQU"
              ? quantity
              : `${quantity} (${lot})`;
          return <div>{data}</div>;
        },
      },
      {
        title: "RATE",
        dataIndex: "tradePrice",
        key: "orderPrice",
        flex: 1,
        align: "left",
        render: (text, record) => {
          const tradePrice = findMarket(record?.marketName)
            ? limitNumberLength(record?.tradePrice)
            : record?.tradePrice?.toFixed(2);
          return <div>{tradePrice}</div>;
        },
      },
      {
        title: "CODE : REJECTION REASON",
        dataIndex: "message",
        key: "message",
        align: "left",
        flex: 1,
        render: (text, record) => {
          const code = `${record?.message?.code} : ${record?.message?.text}`;
          return <span>{code}</span>;
        },
      },
      {
        title: "USER IP",
        dataIndex: "tradeIpAddress",
        key: "tradeIpAddress",
        align: "left",
        flex: 1,
        render: (text, record) => {
          return <div>{record?.tradeIpAddress}</div>;
        },
      },
      isAllow && addition?.acceptRejectedTrade
        ? {
          title: "ACTION",
          dataIndex: "action",
          key: "action",
          flex: 1,
          align: "center",
          render: (text, record, index) => {
            return (
              // <Popconfirm
              //   title="Allow the trade"
              //   description="Are you sure to allow this trade?"
              //   onConfirm={() => {
              //     setShowModal({ flag: true, record: record });
              //     // handleExecute(record, index)
              //   }}
              //   // onCancel={cancel}
              //   okText="Yes"
              //   cancelText="No"
              //   placement="bottomRight"
              // >
              <styleTheme.AllowButton
                type="primary"
                onClick={() => {
                  setShowModal({ flag: true, record: record });
                  // handleExecute(record, index)
                }}
              >
                Allow
              </styleTheme.AllowButton>
              // </Popconfirm>
            );
          },
        }
        : { flex: 1 },
    ];

    return (
      <Col span={24}>
        <DashboardCommonTable
          columns={rejectionColumn}
          dataSource={
            totalData?.[0] ? totalData?.filter((el) => !el?.incognito) : []
          }
          isLoading={tradeQuery.isLoading}
          tableTitle="REJECTION LOGS"
          queryKey="rejectionLogs"
          viewMore={true}
          tradeQuery={tradeQuery}
          emptyPage={
            tradeQuery?.data?.pages?.[0]?.childRejectionLogs?.length === 0
          }
          rowClassName={(record) =>
            record?.tradePattern === "buy" ? "buy-row" : "sell-row"
          }
        // allowBtn={true}
        />
        {showModal?.flag && (
          <VerificationModal
            handleCancel={handleCancel}
            record={showModal?.record}
            handleExecute={handleExecute}
            query={["rejectionLogs"]}
            type="execute"
            title={"Execute Rejection Trade"}
            executeLoading={loading}
          />
        )}
      </Col>
    );
  }
);

export default RejectionLogsTable;
